import { render } from "./sosVue.vue?vue&type=template&id=5c805f7e&scoped=true"
import script from "./sosVue.vue?vue&type=script&lang=js"
export * from "./sosVue.vue?vue&type=script&lang=js"

import "../assets/css/animauxnew.css?vue&type=style&index=0&id=5c805f7e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c805f7e"]])

export default __exports__